import { Types } from './types'

const initialState = {
    dataHistory: {
        rows: [],
        paging: {},
    },
}
const historyAssetReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_HISTORY:
            return {
                ...newState,
                dataHistory: action.payload
            }
        default:
            return { ...newState }
    }
}
export default historyAssetReducer
